module.exports = __webpack_public_path__ + "img/calendar.5a62f581.svg";